// Mock data for MaxGolf Marketing website

export const services = [
  {
    id: 1,
    title: "Media Planning and Buying",
    description: "Strategic media placement to maximize your golf brand's reach and impact across digital and traditional channels.",
    icon: "TrendingUp"
  },
  {
    id: 2,
    title: "Banner Design and Creation",
    description: "Eye-catching banner designs that capture attention and drive engagement for your golf marketing campaigns.",
    icon: "Layout"
  },
  {
    id: 3,
    title: "Video Production",
    description: "Professional video content that showcases your golf brand's story and connects with your audience.",
    icon: "Video"
  },
  {
    id: 4,
    title: "Digital Campaigns",
    description: "Comprehensive digital marketing campaigns tailored for the golf industry to drive results.",
    icon: "Laptop"
  },
  {
    id: 5,
    title: "Programmatic Campaigns",
    description: "Automated ad buying and optimization to reach your target golf audience efficiently.",
    icon: "Target"
  },
  {
    id: 6,
    title: "Email Marketing",
    description: "Engaging email campaigns that nurture relationships and convert golf enthusiasts into customers.",
    icon: "Mail"
  },
  {
    id: 7,
    title: "Search (SEO & PPC)",
    description: "Boost your visibility with search engine optimization and pay-per-click campaigns designed for golf businesses.",
    icon: "Search"
  },
  {
    id: 8,
    title: "Social Media",
    description: "Build and engage your golf community across social platforms with strategic content and campaigns.",
    icon: "Share2"
  },
  {
    id: 9,
    title: "Reporting and Analytics",
    description: "Fully custom reporting on all aspects to enhance performance and drive data-informed decisions.",
    icon: "BarChart3"
  }
];

export const caseStudies = [
  {
    id: 1,
    title: "Premium Golf Resort Campaign",
    client: "Luxury Golf Resort",
    category: "Digital Marketing",
    description: "Increased bookings by 150% through targeted digital campaigns and social media strategy.",
    results: [
      "150% increase in bookings",
      "3x social media engagement",
      "45% reduction in cost per acquisition"
    ],
    image: "https://customer-assets.emergentagent.com/job_maxgolf-site/artifacts/vnie0zpq_IMG_8999.jpg",
    year: "2024"
  },
  {
    id: 2,
    title: "Golf Equipment Brand Launch",
    client: "Pro Golf Equipment",
    category: "Brand Strategy",
    description: "Successfully launched a new golf equipment line with comprehensive marketing strategy.",
    results: [
      "Reached 500K+ golfers",
      "$2M+ in first quarter sales",
      "85% brand awareness in target market"
    ],
    image: "https://customer-assets.emergentagent.com/job_maxgolf-site/artifacts/n8tnsijo_IMG_8997.jpg",
    year: "2024"
  },
  {
    id: 3,
    title: "Golf Club Membership Drive",
    client: "Metropolitan Golf Club",
    category: "Lead Generation",
    description: "Drove membership signups through targeted PPC and email campaigns.",
    results: [
      "200+ new memberships",
      "60% conversion rate improvement",
      "ROI of 4.5x"
    ],
    image: "https://customer-assets.emergentagent.com/job_maxgolf-site/artifacts/wqfp3bc8_IMG_8996.jpg",
    year: "2023"
  },
  {
    id: 4,
    title: "Golf Tournament Promotion",
    client: "National Golf Championship",
    category: "Event Marketing",
    description: "Created buzz and drove attendance for major golf tournament through multi-channel campaigns.",
    results: [
      "10K+ tournament attendees",
      "2M+ social media impressions",
      "95% positive sentiment"
    ],
    image: "https://customer-assets.emergentagent.com/job_maxgolf-site/artifacts/41axpfvp_IMG_8998.jpg",
    year: "2023"
  }
];

export const stats = [
  { label: "Years Experience", value: "15+" },
  { label: "Successful Campaigns", value: "200+" },
  { label: "Golf Clients", value: "50+" },
  { label: "ROI Average", value: "3.5x" }
];

export const clients = [
  {
    id: 1,
    name: "Hole19",
    description: "Leading golf GPS and scoring app with millions of users worldwide",
    category: "Mobile App",
    image: "https://customer-assets.emergentagent.com/job_maxgolf-site/artifacts/70y9s26h_Screenshot%202026-02-16%20at%2015.53.44.png",
    services: ["App Marketing", "Digital Strategy", "User Acquisition"]
  },
  {
    id: 2,
    name: "Dan Hendriksen Golf",
    description: "Professional golf coaching and instruction services",
    category: "Golf Professional",
    image: "https://customer-assets.emergentagent.com/job_maxgolf-site/artifacts/ekdtcsmb_Screenshot%202026-02-16%20at%2015.49.42.png",
    services: ["Personal Branding", "Social Media", "Website Development"]
  },
  {
    id: 3,
    name: "Steve Johnston Golf",
    description: "Expert golf coaching and performance training",
    category: "Golf Professional",
    image: "https://customer-assets.emergentagent.com/job_maxgolf-site/artifacts/x2o17469_Screenshot%202026-02-16%20at%2015.50.48.png",
    services: ["Brand Development", "Content Creation", "Digital Marketing"]
  },
  {
    id: 4,
    name: "GolfpunkHQ.com",
    description: "Modern golf lifestyle and culture media publication",
    category: "Media Publication",
    image: "https://customer-assets.emergentagent.com/job_maxgolf-site/artifacts/3ianxm1c_Screenshot%202026-02-16%20at%2015.55.49.png",
    services: ["Content Strategy", "Audience Growth", "Partnership Development"]
  },
  {
    id: 5,
    name: "Souillac Golf & Country Club",
    description: "Premium golf club and resort experience",
    category: "Golf Club",
    image: "https://customer-assets.emergentagent.com/job_maxgolf-site/artifacts/i26c8yjf_31810-00104-souillac-golf-country-club-photo-aspheries-modifier-8688x5792-1-1920x1080.jpg",
    services: ["Membership Marketing", "Brand Positioning", "Digital Campaigns"]
  }
];
